<template>
  <div>
    <device-calibration
      :deviceId="deviceId"
      :deviceStudy="latestDeviceStudy"
      :showStudyContent="showStudyContent"
    />
  </div>
</template>

<script>
import DeviceCalibration from '@/components/widgets/currentReadings/content/DeviceCalibration.vue'

export default {
  name: 'ContinuousMonitoringAndStudyFooter',
  components: {
    'device-calibration': DeviceCalibration,
  },
  props: {
    deviceId: String,
    latestDeviceStudy: Object,
    showStudyContent: Boolean,
  },
}
</script>

<style lang="scss">
div[data-cy='studyWidget'],
div[data-cy='continuousMonitoringWidget'] {
  max-height: 467px;

  .widget-footer-container {
    padding: 0;
  }
}
</style>
